var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTshirtWand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "TShirt",
    transform: "matrix(0.173598,0,0,0.220789,1.33235,1.73089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.868,92.998L94.25,92.998L94.25,63.953C94.25,47.971 94.344,34.908 94.44,34.908C94.566,34.908 97.625,36.698 101.251,38.864C104.879,41.062 107.874,42.789 107.938,42.726C108.348,42.286 122.981,20.056 122.888,19.993C122.824,19.962 116.044,15.472 107.812,10.071L92.832,0.212L83.497,0.12L74.161,0.024L73.341,1.28C70.629,5.362 66.466,7.622 61.578,7.653C56.878,7.685 52.81,5.706 50.098,1.97L48.678,0.055L39.69,0.086C34.738,0.089 30.48,0.182 30.228,0.277C29.85,0.434 0.394,19.651 0.015,19.996C-0.237,20.246 14.965,42.729 15.31,42.603C15.531,42.54 18.59,40.719 22.154,38.552L28.651,34.658L28.651,41.511L39.458,37.964L39.458,25.803L25.372,26.298L17.681,31.612L11.479,22.404L31.648,9.672L38.965,9.641L46.25,9.61L47.322,10.865L47.322,10.866C48.93,12.78 51.894,14.854 54.67,15.952C57.1,16.926 57.351,16.989 61.61,16.989C65.678,16.957 66.182,16.895 68.232,16.109C71.07,14.979 73.247,13.534 75.392,11.369L77.125,9.609L91.222,9.609L112.535,23.095L104.773,32.761L96.591,28.346L84.06,28.344L83.507,56.921L83.444,83.445L39.458,83.445",
    style: {
      fillRule: "nonzero"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.9431,0,0,2.87708,40.995,69.2739)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-12,-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wand"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.959,2.196L18.905,5.059L21.303,6.949L18.253,6.828L17.199,9.69L16.368,6.753L13.318,6.631L15.855,4.937L15.024,2L17.423,3.89L19.959,2.196Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.088,7.839C13.663,7.49 13.035,7.552 12.686,7.977L3.549,19.107C3.2,19.532 3.262,20.161 3.687,20.51L5.227,21.774C5.652,22.123 6.28,22.061 6.629,21.636L15.766,10.505C16.115,10.08 16.053,9.452 15.628,9.103L14.088,7.839Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.797,2.736L10.51,4.488L12.087,5.302L10.332,5.57L10.045,7.322L9.248,5.736L7.493,6.005L8.755,4.756L7.957,3.17L9.535,3.984L10.797,2.736Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.413,15.422L17.701,13.67L16.123,12.855L17.878,12.587L18.165,10.835L18.963,12.421L20.717,12.153L19.455,13.401L20.253,14.988L18.675,14.173L17.413,15.422Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.378,2L13.22,2.979L14.105,3.436L13.121,3.584L12.963,4.562L12.514,3.675L11.53,3.823L12.236,3.126L11.787,2.239L12.672,2.696L13.378,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.832,16.157L14.991,15.179L14.105,14.722L15.089,14.574L15.247,13.595L15.697,14.483L16.68,14.335L15.974,15.031L16.423,15.918L15.538,15.461L14.832,16.157Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.309,8.328L8.403,9.027L8.788,10.105L7.843,9.459L6.937,10.157L7.26,9.06L6.315,8.414L7.459,8.381L7.781,7.284L8.166,8.361L9.309,8.328Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.901,9.829L19.807,9.13L19.422,8.053L20.367,8.699L21.273,8L20.951,9.098L21.895,9.743L20.751,9.776L20.429,10.874L20.045,9.796L18.901,9.829Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirtWand);
export default __webpack_public_path__ + "static/media/tshirt-wand.d97a2cdb0aed5a837462e990dcd6046d.svg";
export { ForwardRef as ReactComponent };